import {t} from "@lingui/core/macro";

import {RequestInfo} from "@khan/shared-core";
import {staticUrl} from "@khan/urls";

/**
 * Verifies if the current browser is unsupported and returns the corresponding
 * block.
 */
export const UnsupportedBrowser = () => {
    if (!RequestInfo.isUnsupportedBrowser) {
        return null;
    }

    const cssText = `
        #old-browser-warning {
            text-align: center;
            padding-bottom: 10px;
        }

        #old-browser-warning > .intro {
            margin-bottom: 10px;
        }

        #old-browser-warning > .intro > h1 {
            margin: 10px;
        }

        #old-browser-warning .upgrade-option {
            display: inline-block;
            text-align: center;
            width: 120px;
            margin-left: 5px;
            margin-right: 5px;
            padding: 5px;
            background: #EEE;
            border-radius: 4px;
            color: black;
            text-decoration: none;
        }

        #old-browser-warning .upgrade-option:hover {
            background: #DDD;
        }

        #old-browser-warning .upgrade-option:focus {
            background: #DDD;
        }

        #old-browser-warning .upgrade-option > img {
            width: 80px;
            height: 80px;
        }

        #old-browser-warning .upgrade-option > span {
            display: block;
            font-size: 15px;
            font-weight: bold;
        }
    `;

    return (
        <>
            <div id="old-browser-warning" style={{display: "none"}}>
                <div className="intro">
                    <h1>{t`Khan Academy does not support this browser.`}</h1>
                    <div>
                        {t`To use Khan Academy you need to upgrade to another web browser.`}
                        {t`Just select one of the options below to start upgrading.`}
                    </div>
                </div>
                <div className="upgrade-options">
                    {/* eslint-disable-next-line jsx-a11y/no-aria-hidden-on-focusable -- TODO: Address a11y error */}
                    <a
                        className="upgrade-option"
                        aria-hidden="true"
                        href="https://mozilla.org/firefox"
                    >
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/ie-warning/browser_firefox.png",
                            )}
                            aria-hidden="true"
                        />
                        <span>{t`Mozilla Firefox`}</span>
                    </a>
                    <a
                        className="upgrade-option"
                        href="https://microsoft.com/edge"
                    >
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/ie-warning/browser_edge.png",
                            )}
                            aria-hidden="true"
                        />
                        <span>{t`Microsoft Edge`}</span>
                    </a>
                    <a
                        className="upgrade-option"
                        href="https://google.com/chrome"
                    >
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/ie-warning/browser_chrome.png",
                            )}
                            aria-hidden="true"
                        />
                        <span>{t`Google Chrome`}</span>
                    </a>
                </div>
            </div>
            <style>{cssText}</style>
        </>
    );
};
